export const FEATURE_NAME = '@vshosting/cdn/page/+authorize';
